<template>
  <div class="row" v-if="vendors != null && projects != null && products != null">
    <div class="col-md-12">
      <fieldset :disabled="pageType === 'view'">
        <div class="widget fluid">
          <div class="whead">
            <h6>Basic Info</h6>
          </div>
          <div class="card-body card-block">
            <form
              action
              method="post"
              enctype="multipart/form-data"
              class="form-horizontal"
              v-on:submit.prevent="save()"
            >
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="ref_no" class="form-control-label" v-required>Ref No</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="ref_no"
                    name="ref_no"
                    placeholder
                    class="form-control"
                    v-model="input.ref_no"
                    ref="ref_no"
                    readonly
                    disabled
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="created_at" class="form-control-label" v-required>Project Date</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="created_at"
                    name="created_at"
                    placeholder
                    class="form-control"
                    v-model="input.created_at"
                    ref="created_at"
                    readonly
                    disabled
                  >
                </div>
              </div>
              <!-- <div class="row form-group">
                <div class="col col-md-3">
                  <label for="project_id" class="form-control-label">Project Code</label>
                </div>
                <div class="col-12 col-md-9">
                  <model-select :options="projectOptions"
                    v-model="input.project_id"
                    placeholder="Select Project Code"
                    :isDisabled="pageType === 'view'"  
                  >
                  </model-select>
                </div>
              </div> -->
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="vendor_id" class="form-control-label" v-required>Vendor</label>
                </div>
                <div class="col-12 col-md-9">
                  <model-select :options="vendorsOptions"
                    v-model="input.vendor_id"
                    placeholder="Select Vendor"
                    :isDisabled="pageType === 'view' || pageType === 'edit'"  
                  >
                  </model-select>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="hs_partno" class="form-control-label">HS Part No</label>
                </div>
                <div class="col-12 col-md-9">
                  <model-select :options="productOptions"
                    v-model="input.product_id"
                    placeholder="Select HS Part No"
                    :isDisabled="true"  
                  >
                  </model-select>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="vendor_partno" class="form-control-label">Vendor Part No</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="vendor_partno"
                    name="vendor_partno"
                    placeholder
                    class="form-control"
                    v-model="input.vendor_partno"
                    ref="vendor_partno"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="vendor_specsheet" class="form-control-label">Vendor Spec Sheet</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="radio"
                    id="vendor_specsheet"
                    name="vendor_specsheet"
                    placeholder
                    value="0"
                    v-model="input.vendor_specsheet"
                    ref="vendor_specsheet"
                  >No
                  <input
                    type="radio"
                    id="vendor_specsheet"
                    name="vendor_specsheet"
                    placeholder
                    value="1"
                    v-model="input.vendor_specsheet"
                    ref="vendor_specsheet"
                  >Yes
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="status" class="form-control-label" v-required>Status</label>
                </div>
                <div class="col-12 col-md-9">
                  <select id="status" v-model="input.status" class="form-control" :disabled="pageType === 'view'">
                    <option value="">-</option>
                    <option value="Launch">Launch</option>
                    <option value="EOL">EOL</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        </div>
      </fieldset>
      <div class="card-footer"></div>
    </div>
  </div>
</template>
<script>

import { ModelSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

import save from 'src/global/save.js'
import back from 'src/global/back.js'
import getData from 'src/global/getData.js'
import createItem from 'src/global/createItem.js'
import updateItem from 'src/global/updateItem.js'
import validation from 'src/global/validation.js'

import VendorProjectModel from './model/VendorProject'

export default {
  components: {
    ModelSelect
  },
  data() {
    return {
      pageSettings: {
        pageTitle: 'Vendor Project',
        sectionName: 'vendorproject',
        sectionIcon: 'fab fa-buffer',
        type: this.pageType,
        useDefault: false,
        webService: this.$root.WebService.vendorproject,
        navigation: [
          { name: 'Vendor Project', route: 'vendorproject.index' },
          { name: this.$options.filters.capitalize(this.pageType) },
        ],
        buttons: [
          (this.pageType !== 'view' ? { name: 'Save', icon: 'fas fa-save', action: this.save } : null),
          { name: 'Back', icon: 'fas fa-arrow-left', action: this.back },
        ],
        subSidebar: {
          buttons: [
            { name: 'Vendor Project', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'vendorproject.index' }) } },
            { name: 'Project', icon: 'fab fa-buffer', action: () => { this.$router.push({ name: 'project.index' }) } },
          ]
        }
      },
      input: VendorProjectModel(),
      requiredInput: [
        {key: 'vendor_id', title: 'Vendor'},
        {key: 'status', title: 'Status'},
      ],

      vendors: null,
      vendorOptions: [],

      projects: null,
      projectOptions: [],

      products: null,
      productOptions: [],

      modelID: this.$route.params.id ? this.$route.params.id : null,
      processing: false,
    }
  },
  props: {
    pageType: String
  },
  computed: {
    isDisabled() {
      return this.processing
    },
  },
  created() {
    this.getVendors()
    this.getProjects()
    this.getProducts()
    this.getData()
  },
  mounted() {
    this.$emit('setPageHeader', this.pageSettings)
  },
  methods: {
    getVendors() {
      this.$http
        .get(this.WebService.vendor + '?enabled=1')
        .then((response) => {
          this.vendors = response.data.data
          this.vendorsOptions = []

          this.vendors.forEach(element => {
            this.vendorsOptions.push({
              value: element.id,
              text: '[' + element.short_name + '] ' + element.name +  ' (' + element.code + ')'
            })
          })

        })
        .catch((err) => {

        })
        .finally(null)
    },
    getProjects() {
      this.$http
        .get(this.WebService.project)
        .then((response) => {
          this.projects = response.data.data

          this.projectOptions = []

          this.projects.forEach(element => {
            this.projectOptions.push({
              value: element.id,
              text: element.project_code
            })
          })

        })
        .catch((err) => {

        })
        .finally(null)
    },
    getProducts() {
      this.$http
        .get(this.WebService.product)
        .then((response) => {
          this.products = response.data.data

          this.productOptions = []

          this.products.forEach(element => {
            this.productOptions.push({
              value: element.id,
              text: element.part_no
            })
          })
        })
        .catch((err) => {

        })
        .finally(null)
    },
    back,
    save,
    getData,
    createItem,
    updateItem,
    validation,
    afterSaveSuccess(res) {
      this.$router.push({ name: this.pageSettings.sectionName + '.index', params: { id: res.data.data.vendor_id }})
    }
  }
}
</script>